import { render, staticRenderFns } from "./SearchGroupDialog.vue?vue&type=template&id=6185ab22&scoped=true&"
import script from "./SearchGroupDialog.vue?vue&type=script&lang=js&"
export * from "./SearchGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6185ab22",
  null
  
)

export default component.exports